<div class="p-error">
  <app-header></app-header>
  
  <div class="wrap">
    <h2>{{'errorPageHeader' | translate}}</h2>
    <p>{{'errorPageText' | translate}}</p>
    <a href="/">{{'errorPageLink' | translate}}</a>
  </div>
</div>
